/*global*/

import template from '../templates/BankAccountModal.ejs';
import ModalFormView from 'commons/views/ModalForm';
import TxTypesTpl from '../templates/BankAccountTxTypes.ejs';
import tooltip from 'helpers/tooltip';
const accountTypes  = {
    '27': [
        {id: 'maybank2u', name: 'Maybank2U'},
        {id: 'maybank2e', name: 'Maybank2E'}
    ],
    '33': [
        {id: 'service', name: 'PB ECP Service (www.pbebank.com)'},
        {id: 'enterprise', name: 'PB Enterprise (www.pbenterprise.com)'}
    ]
};

module.exports = ModalFormView.extend({
    events: function() {
        return Object.assign({}, ModalFormView.prototype.events(), {
            'change .js-ext-bank': 'selectBank'
        });
    },

    initialize: function(options) {
        this.options = Object.assign({
            template: template,
            templateExtra: {}
        }, options || {});

        this.options.templateExtra = Object.assign(this.options.templateExtra, {
            banks: app.banks,
            accountTypes: accountTypes
        });

        return ModalFormView.prototype.initialize.apply(this, [this.options]);
    },

    bindHandlers: function() {
        const r = ModalFormView.prototype.bindHandlers.apply(this, arguments);

        this.model.on(
            'change:bankBnmCode',
            this.toggleOrganizationCodeVisibility,
            this
        );
        this.model.on(
            'change:bankBnmCode',
            this.toggleHSBCFieldsVisibility,
            this
        );
        this.model.on(
            'change:bankBnmCode',
            this.toggleAccountTypeVisibility,
            this
        );
        this.model.on(
            'change:bankBnmCode',
            this.toggleAccountType,
            this
        );
        this.model.on(
            'change:bankBnmCode',
            () => this.markMandatoryFields(),
            this
        );
        this.model.on(
            'change:bankBnmCode',
            this.toggleAccountTypeSelected,
            this
        );
        this.model.on(
            'change:accountType',
            this.toggleAccountTypeSelected,
            this
        );
        this.model.on(
            'change:bankBnmCode',
            this.toggleOriginatorIDVisibility,
            this
        );
        this.model.on(
            'change:accountType',
            this.toggleOriginatorIDVisibility,
            this
        );
        this.model.on(
            'change:bankBnmCode',
            this.toggleCompanyCodeVisibility,
            this
        );
        return r;
    },

    selectBank: function(ev) {
        const $el = this.$(ev.currentTarget);
        const $option = $el.find('option:selected');
        const bnmCode = ($option.data('bnm') || '') + ''; //turn to string
        const swiftCode = $option.data('swift') || '';
        const name = $option.data('name') || '';

        this.model.set({
            bankName: name,
            bankBnmCode: bnmCode,
            bankSwiftCode: swiftCode
        });

        this.toggleTxTypes();
        this.updateOrganizationCodeLabel();
        this.toggleDefaultTxTypes();
        this.markMandatoryFields();
    },

    toggleDefaultTxTypes: function() {
        const bankCode = this.model.get('bankBnmCode');
        const supportedTxTypes = this.model.getSupportedTransactionTypes();

        let defaultTxType = '';
        if (bankCode === '18') {
            defaultTxType = '30';
        } else if (supportedTxTypes) {
            defaultTxType = Object.keys(supportedTxTypes)[0];
        }

        this.model.set('transactionType', defaultTxType);
        this.$('[name=transactionType]')
            .val(defaultTxType)
            .change();
    },

    toggleAccountTypeSelected: function() {
        if (!this.model) {
            return;
        }
        const selected = this.model.get('accountType');
        const bankCode = this.model.get('bankBnmCode');
        if (bankCode === '33') {
            const showOrganizationCode = selected === 'service';
            this.$('[name=organizationCode]')
                .closest('.form-group')
                .toggleClass('hidden', !showOrganizationCode);
            this.toggleTxTypes();
            this.markMandatoryFields();
        }

        if (bankCode === '27') {
            const showOrganizationCode = selected === 'maybank2e';
            this.$('[name=organizationCode]')
                .closest('.form-group')
                .toggleClass('hidden', !showOrganizationCode);
            this.toggleTxTypes();
            this.markMandatoryFields();
        }
    },

    toggleTxTypes: function() {
        this.$('.js-tx-types').html('');

        if (!this.model) {
            return;
        }

        /* Not as simple as hiding an input like organizationCode, therefore we
         just render the tx types partial when required */
        /* In retrospect, toggling inputs like organizationCode would have been
         * easier, being that not all banks that support TxTypes require the
         * exact same information */
        // TODO Get rid of the partial and toggle fields instead
        let txTypes = this.model.getSupportedTransactionTypes();

        if (this.model.get('isPayer') && txTypes) {
            txTypes = Object.keys(txTypes).map(k => {
                return {
                    type: k,
                    desc: txTypes[k]
                };
            });
            const txTypesRender = TxTypesTpl({
                organizationCode: this.model.get('organizationCode'),
                transactionType: this.model.get('transactionType'),
                rentasTxCode: this.model.get('rentasTxCode'),
                txTypes: txTypes
            });
            this.$('.js-tx-types').html(txTypesRender);
            tooltip.init(this);
        }

        this.delegateEvents();
    },

    render: function() {
        let r = ModalFormView.prototype.render.apply(this, arguments);
        this.toggleTxTypes();
        this.toggleOrganizationCodeVisibility();
        this.toggleHSBCFieldsVisibility();
        this.toggleOriginatorIDVisibility();
        this.toggleAccountTypeVisibility();
        this.toggleCompanyCodeVisibility();
        this.updateOrganizationCodeLabel();
        this.markMandatoryFields();
        this.toggleAccountTypeSelected();

        return r;
    },

    updateOrganizationCodeLabel: function() {
        if (!this.model) {
            return;
        }

        const bankCode = this.model.get('bankBnmCode');
        const $label = this.$('.js-organization-code-label');
        if (bankCode === '18') {
            $label.text('Corporate ID');
        } else {
            $label.text('Organization Code');
        }
    },

    toggleOrganizationCodeVisibility: function() {
        if (!this.model) {
            return;
        }
        const usingOrganizationCode = ['33', '35', '18'];
        const bankCode = this.model.get('bankBnmCode');

        this.$('[name=organizationCode]').closest('.form-group')
            .toggleClass('hidden', (
                !usingOrganizationCode.includes(bankCode) ||
                !this.model.get('isPayer')
            ));
    },

    toggleOriginatorIDVisibility: function() {
        if (!this.model) {
            return;
        }
        const bankCode = this.model.get('bankBnmCode');
        const accountType = this.model.get('accountType');

        this.$('[name=originatorId]').closest('.form-group')
            .toggleClass('hidden', (
                !(bankCode === '27' && accountType === 'maybank2u')
            ));
        this.markMandatoryFields();
    },

    toggleCompanyCodeVisibility: function() {
        if (!this.model) {
            return;
        }
        const bankCode = this.model.get('bankBnmCode');

        this.$('[name=companyCode]').closest('.form-group')
            .toggleClass('hidden',
                !(bankCode === '26' && this.model.get('isPayer'))
            );
        this.markMandatoryFields();
    },

    toggleHSBCFieldsVisibility: function() {
        if (!this.model) {
            return;
        }
        const bankCode = this.model.get('bankBnmCode');

        this.$('.hsbc-fields')
            .toggleClass('hidden', (
                !(bankCode === '22' && this.model.get('isPayer'))
            ));
    },

    toggleAccountTypeVisibility: function() {
        if (!this.model) {
            return;
        }
        const bankCode = this.model.get('bankBnmCode');
        this.$('.js-ext-account-type-container')
            .toggleClass('hidden', (
                accountTypes[bankCode] === undefined ||
                !this.model.get('isPayer')
            ));
        this.$('.js-ext-account-type-opt').addClass('hidden');
        this.$(`.js-ext-account-type-opt-${bankCode}`)
            .removeClass('hidden');
    },

    toggleAccountType: function() {
        let types = accountTypes[this.model.get('bankBnmCode')] || [];
        let type = _.find(types, type => {
            return type.id === this.model.get('accountType');
        });
        if (!type) {
            this.model.set('accountType', '', {validate: false});
            this.renderAttribute(this.model, 'accountType');
            return;
        }
    }
});



// WEBPACK FOOTER //
// ./app/commons/views/BankAccountModal.js